exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.image-wrapper img[data-v-b2af3206]{width:100%;height:auto\n}", ""]);

// exports
